<app-dialog-container [showCloseButton]="false">
    <ng-container dialog-header>
        {{data.actionButton.text}}
    </ng-container>
    <ng-container dialog-content>
        <div class="modal-content px-3" [innerHTML]="data.actionButton.modalText"></div>
    </ng-container>

    <ng-container dialog-actions>
        <div class="w-full flex justify-center">
            <button data-dialog-close
                class="btn w-36 uppercase text-xs bg-main opacity-70 hover:opacity-100 hover:text-white transition-opacity duration-300">Close</button>
        </div>
    </ng-container>
</app-dialog-container>